<template>
    <div class="MemberList">
        <div class="header">
            <el-row>
                <el-col :span="8">
                    <label class="headerlabel">用户信息</label>
                    <el-input v-model="param.searchValue" placeholder="请输入用户编号/昵称/手机号" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">会员类型</label>
                    <el-select v-model="param.memberLevel" placeholder="请选择" filterable  class="autowidth" clearable >
                        <el-option v-for="item in MemeberPackageData" :label="item.packageName" :kye="item.memberPackageId" :value="item.memberPackageId"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">最后支付时间</label>
                    <el-date-picker
                    class="autowidth"
                    clearable
                    v-model="Finalpaymenttime"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
                <el-col :span="16">
                    <label class="headerlabel">到期时间</label>
                    <el-date-picker
                    v-model="param.expirationTime"
                    class="autowidth" 
                    clearable
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                    </el-date-picker>

                    <el-button type="primary" style="margin-left: 24px;" @click="init">筛选</el-button>
                    <el-button @click="reset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-table
            :data="MemberData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%;margin-bottom: 20px;">
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column label="头像">
                    <template slot-scope="scope">
                        <img v-if="scope.row.zHeadPhotoURL" :src="scope.row.zHeadPhotoURL" style="width: 40px;height: 40px;border-radius: 50%;">
                    </template>
                </el-table-column>
                <el-table-column prop="realName" label="用户昵称"></el-table-column>
                <el-table-column prop="phone" label="手机号码"></el-table-column>
                <el-table-column prop="PackageTag" label="会员类型"></el-table-column>
                <el-table-column prop="expirationTime" label="到期时间"></el-table-column>
                <el-table-column prop="accumulateAmount" label="累计消费"></el-table-column>
                <el-table-column prop="addTime" label="最后支付时间"></el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageNum"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

    </div>
</template>
<script>
export default{
    data() {
        return {
            Finalpaymenttime:[],
            loading:false,
            param:{
                pageNum:1,
                pageSize:10,
                PageTotal:0,
                searchValue: "",
                memberLevel: "",
                memberStatus: "",
                memberBirthday: "",
                expirationTime: "",
                startAddTime: "",
                endAddTime: ""
            },
            MemberData:[],
            searchValue:'',
            MemeberPackageData:[],
        }
    },
    watch:{
        Finalpaymenttime(newval,oldval){
            if(newval==null){
                this.param.startExpiration=''
                this.param.endExpiration=''
            }else{
                this.param.startExpiration=newval[0]
                this.param.endExpiration=newval[1]
            }
        },
    },
    mounted() {
        this.init();
        this.MemeberPackage();
    },
    methods:{
        // 查询会员类型(会员套餐接口)
        MemeberPackage(){
            this.$Http_Post('/kg/package/list',{searchValue:this.searchValue}).then(res=>{
                if(res.Code==0){
                    this.MemeberPackageData=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        init(){
            this.loading=true;
            this.$Http_Post('/kg/member/list',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.param.PageTotal=res.Counts;
                    this.MemberData=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        reset(){
            this.param=this.$options.data().param;
            this.init();
        },
        handleinitialization(val){
            this.param.pageNum=val;
            this.init();
        }
    },
}
</script>
<style>
.MemberList .header{background: #fff;padding:20px;}
.MemberList .header .headerlabel{width:90px;display: inline-block;}
.MemberList .header .autowidth{width: 240px;}
.MemberList .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
</style>